export default __webpack_public_path__ + "static/padding-16101e17b1c3c2683b20568418f9ce5f.png";